import { apiUrl1, apiUrl2, apiUrl4 } from "../configs/constant";
import CryptoJS from 'crypto-js';
import { generateRandomKey } from "./format-data";
const password = process.env.REACT_APP_PASSWORD;

export const getMezcalIndexer = async (query, status, page, limit) => {
  const url = `${apiUrl4}/mezcal`;

  const data = {
    url: `mezcal/etchings/all?limit=${limit}&page=${page}&status=${status}&q=${query}`
  }
  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getMezcalUtxo = async (utxo) => {
  const url = `https://mezcal.sh/api/mezcal/balances/utxo/${utxo}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getMezcalHoldersList = async (protocolId, page, limit) => {
  const url = `${apiUrl4}/mezcal`;

  const data = {
    url: `mezcal/etchings/holders/${protocolId}?limit=${limit}&page=${page}`
  }
  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getMezcalTickerDetail = async (ticker) => {
  const url = `${apiUrl4}/mezcal`;

  const data = {
    url: `mezcal/etchings/info/${ticker}`
  }
  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}
export const getMezcalBalance = async (address, page, limit) => {
  const url = `${apiUrl4}/mezcal`;

  const data = {
    url: `mezcal/balances/address/${address}?limit=${limit}&page=${page}`
  }
  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getMezcalBalanceUtxo = async (address) => {
  const url = `${apiUrl4}/mezcal`;

  const data = {
    url: `mezcal/utxos/${address}`
  }
  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getMezcalTradeListByAddress = async (ticker, address) => {
  const url = `${apiUrl4}/mezcal`;

  const data = {
    url: `mezcal/utxos/${address}`
  }
  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  let results = await response.json();

  let tempDatas = [];
  let txIds = [];
  for(let result of results.data) {
    if (result.mezcal.mezcal_protocol_id == ticker) {
      let balances = [];
      for(let tempResult of results.data) {
        if (tempResult.utxo.transaction == result.utxo.transaction && tempResult.utxo.vout_index == result.utxo.vout_index) {
          balances.push({
            ticker: tempResult.mezcal.mezcal_protocol_id,
            name: tempResult.mezcal.name,
            symbol: tempResult.mezcal.symbol,
            decimals: tempResult.mezcal.decimals,
            amount: parseInt(tempResult.balance) / 10 ** result.mezcal.decimals,
          });
        }
      }

      tempDatas.push({
        ticker: ticker,
        name: result.mezcal.name,
        symbol: result.mezcal.symbol,
        decimals: result.mezcal.decimals,
        txId: result.utxo.transaction + ":" + result.utxo.vout_index,
        vout: result.utxo.vout_index,
        value: parseInt(result.utxo.value_sats),
        amount: parseInt(result.balance) / 10 ** result.mezcal.decimals,
        balances: balances
      })
      txIds.push(result.utxo.transaction + ":" + result.utxo.vout_index);
    }
  }

  if (txIds.length > 0) {
    let tradeResults = await getMezcalTradeListByTxIds(txIds);
    for(let tradeResult of tradeResults) {
      for(let tempData of tempDatas) {
        if (tempData.txId == tradeResult.utxoTxId) {
          tempData.tradeId = tradeResult.id;
          tempData.unitPrice = tradeResult.unitPrice;
          tempData.totalPrice = tradeResult.totalPrice;
        }
      }
    }
  }

  return tempDatas;
}

const getMezcalTradeListByTxIds = async (txIds) => {
  const url = `${apiUrl4}/mezcal/trade/listByTxIds`;
  const data = {
    txIds: txIds
  }

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}


export const getMezcalCheckTicker = async (tick) => {
  const url = `${apiUrl4}/mezcal/checkTicker?tick=${tick}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getMezcalTrade = async (page, limit, ticker, order, direction, duration) => {
  const url = `${apiUrl4}/mezcal/trade?page=${page}&limit=${limit}&query=${ticker}&order=${order}&direction=${direction}&duration=${duration}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getMezcalTradeActivity = async (ticker, mode, page, limit) => {
  const url = `${apiUrl4}/mezcal/trade/activity?ticker=${ticker}&mode=${mode}&page=${page}&limit=${limit}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getMezcalTradeByTicker = async (ticker, duration) => {
  const url = `${apiUrl4}/mezcal/tradeByTicker?query=${ticker}&duration=${duration}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getMezcalTradeList = async (page, limit, ticker, order, direction) => {
  const url = `${apiUrl4}/mezcal/trade/list?page=${page}&limit=${limit}&ticker=${ticker}&order=${order}&direction=${direction}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const getMezcalTradeCheck = async (id) => {
  const url = `${apiUrl4}/mezcal/trade/check?id=${id}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

export const saveMezcalTradeData = async (data) => {
  const url = `${apiUrl2}/mezcal/trade/register`;
  data.randomKey = generateRandomKey(16);
  data.randomKeyHash = CryptoJS.AES.encrypt(data.randomKey, password).toString();

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getMezcalPSBTForBuy = async (data) => {
  const url = `${apiUrl1}/mezcal/generatePsbtForBuy`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getMezcalPSBTForMezcalSplit = async (data) => {
  const url = `${apiUrl1}/mezcal/generatePsbtForMezcalSplit`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}

export const getMezcalPSBTForSplit = async (data) => {
  const url = `${apiUrl1}/mezcal/generatePsbtForSplit`;

  let response  = await fetch(url, {
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  return await response.json();
}


export const createMezcalTradeHistory = async (ticker) => {
  const url = `${apiUrl4}/mezcal/trade/create?ticker=${ticker}`;

  let response  = await fetch(url, {
    method: 'GET', 
    headers: {
      'Content-Type': 'application/json',
    }
  })

  return await response.json();
}

